<template>
  <div class="contact-page">
    <!-- 头部 -->
    <AppHeader />

    <!-- Banner -->
    <div class="banner" :style="{ backgroundImage: 'url(' + bannerImage + ')' }"></div>

    <!-- 悦动态介绍 -->
    <section class="section intro-section">
      <div class="container">
        <div class="intro-wrapper">
          <div class="intro-image">
            <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAg-a67zwYotJSlqAQw0wQ4hgg.png" alt="悦动态">
          </div>
          <div class="intro-content">
            <h2 class="intro-title">悦动态</h2>
            <p class="intro-desc">智慧企业运动健康管理系统，用互联网+AI运动+游戏化的运营思路，结合大数据，AI智能检测服务于各大企业。</p>
            <p class="intro-desc">智能企业运动服务管理可以根据企业需求做更多定制化的服务，包括企业运动管理，企业专属赛事，企业文化建设，植入企业现有服务系统等。</p>
            <p class="intro-desc">
              对企业负责，提供企业专属视觉与内容赋能，优化福利品质：提供合规高效的福利发放方案，提升管理效率，助力企业文化建设；对员工负责，提升生活品质：提供全方位优质商品选择，满足个性化需求，让福利更具实用性。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 线上趣味云赛事 -->
    <section class="section sports-section">
      <div class="container">
        <h2 class="section-main-title" style="font-size: 36px;">线上趣味云赛事</h2>
        <p class="section-subtitle">——</p>
        <p class="section-desc">通过数字体育的创新技术叠加游戏化的赛制，充分调动员工积极性，让运动和生活更有趣。功能包括：跑步、徒步、AI运动（跳绳、开合跳、平板支撑、仰卧起坐、俯卧撑、深蹲、自定义运动等）
        </p>

        <!-- 中心辐射图 -->
        <div class="sports-diagram-wrapper">
          <img class="sports-diagram-bg" src="../src/assets/ic.png" alt="赛事流程图">
          <!-- <div class="sports-overlay">
            <div class="overlay-card pos-left-top">
              <div class="overlay-title">定制性赛事与活动</div>
              <p class="overlay-text">健步走活动，诗歌朗诵活动，在线答题活动，投票活动，趣味积分赛，运动打卡赛，运动排位赛，运动达标赛</p>
            </div>
            <div class="overlay-card pos-right-top">
              <div class="overlay-title">运动达标赛</div>
              <p class="overlay-text">通过记录运动过程，运动时长或打卡完成度来对参与者或参与团队进行排名</p>
            </div>
            <div class="overlay-card pos-center">
              <h4 class="center-title">企业服务线上运动的意义</h4>
              <p class="center-desc">营造快乐氛围，彰显企业文化，成为企业信赖的活动管家</p>
            </div>
            <div class="overlay-card pos-left-mid">
              <div class="overlay-title">诗歌朗诵活动</div>
              <p class="overlay-text">用户在参与活动后上传自己的诗歌作品，企业其他用户可以对其作品进行投票，根据投票得分进行排名</p>
            </div>
            <div class="overlay-card pos-right-mid">
              <div class="overlay-title">在线答题活动</div>
              <p class="overlay-text">管理员通过系统自带的个性化题库发布在线答题活动，根据答对的题目数量排名</p>
            </div>
            <div class="overlay-card pos-left-bottom">
              <div class="overlay-title">节日限定活动</div>
              <p class="overlay-text">由参与者发布与主题相关的作品，他人投票，根据投票得分进行排名，或管理员发布节日在线答题活动与节日打卡运动</p>
            </div>
            <div class="overlay-card pos-right-bottom">
              <div class="overlay-title">趣味积分赛</div>
              <p class="overlay-text">管理员设置所需完成的运动任务并标明运动对应积分，参与成员或团队完成后可获得对应积分</p>
            </div>
          </div> -->
        </div>
      </div>
    </section>

    <!-- 定制活动 -->
    <section class="section custom-section">
      <div class="container">
        <div class="section-label">PREFERRED BRAND</div>
        <h2 class="section-heading">定制活动</h2>
        <div class="custom-logos">
          <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAg07q7zwYo6u_Kvwcwggg45AU.png" alt="定制活动">
        </div>
      </div>
    </section>

    <!-- 底部 -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/head.vue'
import AppFooter from '@/components/foot.vue'

export default {
  name: 'Contact',
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      bannerImage: '//34188381.s21i.faiusr.com/4/ABUIABAEGAAg3q28zwYouYq0iQEwqAs41AU.png'
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif;
  color: #353535;
  line-height: 1.6;
}

.contact-page {
  background: #fff;
}

.banner {
  height: 800px;
  background-size: 100% auto;
  background-position: 50% 50%;
  background-repeat: no-repeat;
}

.section {
  padding: 60px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-label {
  text-align: center;
  color: #e5e5e5;
  font-size: 36px;
  font-weight: bold;
}

.section-heading {
  text-align: center;
  color: #353535;
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 30px;
}

/* 悦动态介绍 */
.intro-wrapper {
  text-align: left;
  display: flex;
  gap: 0;
}

.intro-image {
  flex: 0;
}

.intro-image img {
  width: 300px;
}

.intro-content {
  flex: 1;
  padding-top: 60px;
}

.intro-title {
  font-size: 28px;
  color: #353535;
  margin-bottom: 30px;
}

.intro-desc {
  font-size: 20px;
  line-height: 2em;
  color: #666;
  margin-bottom: 20px;
}

/* 线上趣味云赛事 */
.sports-section {}

.section-main-title {
  text-align: center;
  font-size: 30px;
  color: #000;
  font-weight: bold;
  margin-bottom: 5px;
}

.section-subtitle {
  text-align: center;
  font-size: 24px;
  color: #000333;
  margin-bottom: 15px;
}

.section-desc {
  text-align: center;
  font-size: 16px;
  color: #999;
  max-width: 849px;
  margin: 0 auto 40px;
  line-height: 1.8;
}

/* 中心辐射图 */
.sports-diagram-wrapper {
  position: relative;
  width: 1174px;
  margin: 0 auto;
  /* min-height: 560px; */
}

.sports-diagram-bg {
  width: 100%;
  height: auto;
  display: block;
}

.sports-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.overlay-card {
  position: absolute;
  pointer-events: auto;
  text-align: center;
}

.overlay-title {
  font-size: 16px;
  font-weight: bold;
  color: #353535;
  margin-bottom: 8px;
}

.overlay-text {
  font-size: 14px;
  color: #999;
  line-height: 1.6;
}

/* 位置-基于原网站绝对定位换算 */
.pos-left-top {
  top: 14%;
  left: 14%;
  width: 200px;
}

.pos-right-top {
  top: 2%;
  right: 0;
  width: 200px;
}

.pos-center {
  top: 38%;
  left: 50%;
  transform: translateX(-50%);
  width: 200px;
}

.center-title {
  font-size: 16px;
  font-weight: bold;
  color: #353535;
  margin-bottom: 8px;
}

.center-desc {
  font-size: 14px;
  color: #999;
}

.pos-left-mid {
  top: 52%;
  left: 0;
  width: 200px;
}

.pos-right-mid {
  top: 47%;
  right: 14%;
  width: 220px;
}

.pos-left-bottom {
  top: 76%;
  left: 25%;
  width: 200px;
}

.pos-right-bottom {
  top: 80%;
  right: -2%;
  width: 200px;
}

/* 定制活动 */
.custom-logos {
  text-align: center;
  margin-top: 20px;
}

.custom-logos img {
  max-width: 100%;
  height: auto;
}

@media (max-width: 768px) {
  .intro-wrapper {
    flex-direction: column;
  }

  .intro-image {
    flex: none;
  }

  .sports-diagram-bg {
    display: none;
  }

  .sports-diagram-wrapper {
    min-height: auto;
  }

  .sports-overlay {
    position: static;
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    justify-content: center;
  }

  .overlay-card {
    position: static !important;
    width: calc(50% - 10px) !important;
    transform: none !important;
    background: #fff;
    padding: 15px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }
}
</style>


// WEBPACK FOOTER //
// src/Contact.vue